import { render, staticRenderFns } from "./history-list.vue?vue&type=template&id=3a8fcb6d&scoped=true&"
import script from "./history-list.vue?vue&type=script&lang=js&"
export * from "./history-list.vue?vue&type=script&lang=js&"
import style0 from "./history-list.vue?vue&type=style&index=0&id=3a8fcb6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8fcb6d",
  null
  
)

export default component.exports